import { Store } from 'src/store/index';

const isDesignSaving = (store: Store) => store.design.isSaving;

export default isDesignSaving;
